import { render, staticRenderFns } from "./TableSection.vue?vue&type=template&id=c9d09b4e&scoped=true&"
import script from "./TableSection.vue?vue&type=script&lang=js&"
export * from "./TableSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d09b4e",
  null
  
)

export default component.exports